export const CDN_PREFIX = 'https://cdn.meishakeji.com';
export const CONTENT_TYPE_MAP = [
  {
    value: 0,
    label: '不限'
  },
  {
    value: 1,
    label: '中文'
  },
  {
    value: 2,
    label: '英文'
  },
  {
    value: 15,
    label: '数字'
  },
  {
    value: 17,
    label: '鞋码',
    unit: '码'
  },
  {
    value: 16,
    label: '省市区'
  },
  {
    value: 3,
    label: '日期'
  },
  {
    value: 4,
    label: '电子邮箱'
  },
  {
    value: 5,
    label: '居民身份证'
  },
  {
    value: 6,
    label: '手机号码'
  },
  {
    value: 7,
    label: '电话号码'
  },
  {
    value: 8,
    label: '分秒',
    unit: '分秒'
  },
  {
    value: 9,
    label: '秒',
    unit: '秒'
  },
  {
    value: 10,
    label: '米',
    unit: '米'
  },
  {
    value: 11,
    label: '厘米',
    unit: '厘米'
  },
  {
    value: 12,
    label: '千克',
    unit: '千克'
  },
  {
    value: 13,
    label: '毫升',
    unit: '毫升'
  },
  {
    value: 14,
    label: '次',
    unit: '次'
  }
];
export const VOYAGE_TEMPLATEID = '20210220105515';
